import { Inject, Injectable } from "@angular/core";
import { CacheService } from "ionic-cache";
import { Storage } from '@ionic/storage';
import { logger, OdConfig } from "..";
import { CacheStorageService } from "ionic-cache/dist/cache-storage";
var LoggerStorage = /** @class */ (function () {
    function LoggerStorage(config) {
        this.config = config;
    }
    LoggerStorage.prototype.createLocalDb = function () {
        this._storage = new Storage({
            name: this.config.dbName,
            storeName: "_logger",
            driverOrder: ['indexeddb', 'sqlite', 'websql']
        }, 0);
        this._cacheStorageService = new CacheStorageService(this._storage, this.config.cacheName);
        this._cache = new CacheService(this._cacheStorageService);
    };
    LoggerStorage.prototype.save = function (logVoData) {
        this._storage.set(logVoData.creationDate.getTime() + "-" + this._index++, logVoData).then(function () {
            logger.error("Error - A log was record, please check _logger database");
        });
    };
    LoggerStorage.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LoggerStorage.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
    ]; };
    return LoggerStorage;
}());
export { LoggerStorage };
//# sourceMappingURL=logger-storage.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/storage/logger-storage.js
// module id = 368
// module chunks = 14